import React from 'react';
import { Box, Flex, Text } from 'pounceV2';
import { useTheme } from '@mui/material';
import NotificationV3 from './NotificationV3';
import { GroupedNotifications } from './types';
import CSVNotificationV3 from './CSVNotificationV3';

const NotificationsPerDateV3 = ({
  notificationsGroup,
}: {
  notificationsGroup: GroupedNotifications;
}) => {
  const theme = useTheme();

  return (
    <>
      {Object.entries(notificationsGroup).map(([date, items]) => {
        return (
          <Box key={date}>
            <Flex
              justify="space-between"
              align="center"
              px={6}
              py={3}
              bg={theme.palette.tokens.background.neutral.mid[4]}
            >
              <Text variant="label/lg" fontWeight="semibold" mr={2}>
                {date}
              </Text>
            </Flex>
            {items.map((notification: any) =>
              notification.metadata?.originalQueryId ? (
                <CSVNotificationV3 key={notification.id} notification={notification} />
              ) : (
                <NotificationV3 key={notification.id} notification={notification} />
              ),
            )}
          </Box>
        );
      })}
    </>
  );
};

export default React.memo(NotificationsPerDateV3);
